import { IconTextButtonBlock } from 'components/minute/view/IconTextButtonBlock';
import { motion } from 'framer-motion';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    onChangeShown: (shown: boolean) => void;
    className?: string;
}

export const InteractiveMapMessage = (props: Props): JSX.Element => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function finish(e?: any) {
        e?.stopPropagation(); //does not work
        e?.preventDefault(); //does not work
        props.onChangeShown(false);
    }

    return (
        <S_InteractiveMapMessage
            className={props.className}
            onClick={(e) => {
                finish(e);
            }}
            initial={{ backgroundColor: 'rgba(0, 0, 0, 1)' }}
            animate={{ backgroundColor: 'rgba(0, 0, 0, 0)' }}
            transition={{ duration: 3 }}
            onMouseDown={(e) => {
                finish(e);
            }}
            onTouchStart={(e) => {
                finish(e);
            }}
        >
            <S_MessageWrap>
                <S_IconTextButtonBlock
                    iconName="bullseye-pointer"
                    title={Localization.THIS_IS_INTERACTIVE_MAP}
                    subtitle={Localization.CLICK_ON_INFO}
                    buttonText={Localization.CONTINUE}
                    buttonAction={() => {
                        finish();
                    }}
                />
                <S_AnimatedLine
                    initial={{ width: '100%' }}
                    animate={{ width: '0%' }}
                    transition={{ duration: 5 }}
                    onAnimationComplete={() => {
                        finish();
                    }}
                />
            </S_MessageWrap>
        </S_InteractiveMapMessage>
    );
};

const S_InteractiveMapMessage = styled(motion.div)`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const S_MessageWrap = styled.div`
    width: 300px;
    background-color: white;
    border-radius: 7px;
    box-shadow: 5px 5px 10px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    padding: 0px 20px;
    @media only screen and (min-width: 1260px) {
        width: 400px;
    }
`;

const S_AnimatedLine = styled(motion.div)`
    width: 100%;
    height: 5px;
    background-color: #cdcdcd;
    margin: -5px 0 15px 0;
`;

const S_IconTextButtonBlock = styled(IconTextButtonBlock)``;
